import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for auto-exclusion users table.
 */
export default class tableAutoexclusionUsersView extends JetView {
    /**
     * Configures the datatable for displaying auto-exclusion users.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            view: 'datatable', // Datatable view
            select: true, // Enable row selection
            columns: [
                // Column definitions
                { id: 'Id', header: 'Id', width: 100, sort: 'int' },
                {
                    id: 'PlayerId',
                    header: 'ID Usuario',
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'UserName',
                    header: 'Usuario (Correo electrónico)',
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'State',
                    header: 'Estado',
                    options: [
                        // Dropdown options for State column
                        { id: '', value: 'None' },
                        { id: 'A', value: 'Activado' },
                        { id: 'C', value: 'Canceled' },
                        { id: 'I', value: 'Inactivado' },
                    ],
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Category',
                    header: 'Categorías',
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'SubCategory',
                    header: 'Sub Categoría',
                    width: 100,
                    sort: 'int',
                },
                { id: 'Game', header: 'Juego', width: 100, sort: 'int' },
                {
                    id: 'FinalDate',
                    header: _('Fecha final de la autoexclusión'), // Localized header
                    fillspace: 0,
                    minWidth: 0,
                    width: 250,
                    sort: 'text',
                    format: dateFormat, // Date formatting for FinalDate
                },
                {
                    id: 'UserCreation',
                    header: 'Usuario Creación',
                    width: 200,
                    sort: 'int',
                },
                {
                    id: 'UserModified',
                    header: 'Usuario Modificó',
                    width: 200,
                    sort: 'int',
                },
            ],
            footer: true, // Enable footer
            math: true, // Enable math operations in footer
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            loadahead: 5, // Number of records to load ahead
            pager: 'pagerA', // Pager configuration
            // API endpoint for fetching data
            url: devConfig.geturlApi() + 'null/Report/getRegisteredAutoexclusion',
        };
    }

    /**
     * Initializes the grid and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = grid.data.url; // Store the grid's data URL
        var filter = ''; // Initialize filter string

        // Event handler for filtering data
        this.on(this.app, 'autoexclusionUsers:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string

            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Handle object filters
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add MaxCreatedLocal to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add MinCreatedLocal to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Add current user to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event handler for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event handler for row selection
        grid.attachEvent('onAfterSelect', (obj) => {
            this.app.callEvent('user:id', [obj.Id]); // Trigger user ID event
        });

        // Event handler before data is sent
        grid.attachEvent('onBeforeDataSend', function (send) {
            webix.message('Loading2...'); // Show loading message
        });

        // Event handler for data requests
        grid.attachEvent('onDataRequest', function (start, count) {
            custom_load(this.data.url, start, count); // Custom load function
            return true;
        });

        /**
         * Custom load function to fetch data.
         * @param {string} url - The URL to fetch data from.
         * @param {number} start - The starting index for data.
         * @param {number} count - The number of records to fetch.
         */
        function custom_load(url, start, count) {
            grid.load(
                url + '?start=' + start + '&count=' + count + '&FromId' + cur_user, // Load data with pagination
            );
        }

        // Event handler before loading data
        grid.attachEvent('onBeforeLoad', function () {
            webix.message('Loading...'); // Show loading message
            return true;
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id, // Load data based on selected player
            );
        });
    }
}

// FILE DOCUMENTED
